module.exports = __webpack_public_path__ + "static/media/pxiEyp8kv8JHgFVrJJnecnFHGPezSQ.0ed299a4.woff2";